import React, { FC, useState } from "react";
import {
  Edit,
  EditProps,
  FormTab,
  TabbedForm,
  useDataProvider,
  useEditController,
  useNotify,
  useRefresh,
} from "react-admin";
import { getDrawDate } from "../../helpers/getDrawDateFromCompetitions";
import { makeUpWinnersRequest } from "../../helpers/winnerRequest";
import { WinnerCreateData, WinnerData } from "../../types/winnerRequest";
import DocumentTitle from "../common/documentTitle/DocumentTitle";
import StaffUserFormToolbar from "../staff/StaffUserFormToolBar";
import DescriptionTabForm from "./DescriptionTabForm";
import FormInstruction from "./FormInstructions";

const EditWinner: FC<EditProps> = (props) => {
  const controllerProps = useEditController<any>(props);
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const onSuccess = (winnerId: string) => async (data) => {
    // data.photoUrl.rawFile.size > 500000  -> show error
    if (data.photoUrl && data.photoUrl.rawFile) {
      if (data.photoUrl.rawFile.size > 500000) {
        notify("Photo size more then 500kb", "error");
        return;
      }
    }
    // data.winnerPhotoUrl.rawFile.size > 500000  -> show error
    if (data.winnerPhotoUrl && data.winnerPhotoUrl.rawFile) {
      if (data.winnerPhotoUrl.rawFile.size > 500000) {
        notify("Winner photo size more then 500kb", "error");
        return;
      }
    }
    const { ...rest } = data;
    const winnerData: WinnerCreateData = {
      ...rest,
      drawDate: data.drawDate,
      title: data.name,
      id: winnerId,
    };
    const multipartData = makeUpWinnersRequest(winnerData);
    const result = await dataProvider.update("winners", {
      id: winnerId,
      data: multipartData,
      previousData: {} as WinnerData,
    });

    if (!result.data) {
      notify("something went wrong", "error");
    }
    notify(`Winner successfully update`);
    refresh();
  };

  const validateWinner = (value) => {
    const errors: any = {};

    if (!value.prizeTitle) {
      errors.prizeTitle = "Prize is required";
    }

    if (!value.prizeLabel) {
      errors.prizeLabel = "Prize label is required";
    }

    if (!value.prizeType) {
      errors.prizeType = "Prize type is required";
    }

    if (!value.winnerPhotoUrl && !value.videoUrl) {
      errors.winnerPhotoUrl = "Please choose photo.";

      errors.videoUrl =
        "Please choose video url or upload a photo. At least something should be chosen";
    }
    return Object.keys(errors).length ? errors : undefined;
  };
  return (
    <>
      <DocumentTitle
        core="Winners"
        purpose={`${controllerProps.record?.name}`}
        appointment=""
      />
      <FormInstruction />
      <Edit {...props}>
        {controllerProps.record && (
          <TabbedForm
            toolbar={
              <StaffUserFormToolbar
                onSuccess={onSuccess(controllerProps.record.id)}
                {...props}
              />
            }
            validate={validateWinner}
          >
            <FormTab label="Description">
              <DescriptionTabForm record={controllerProps.record} {...props} />
            </FormTab>
          </TabbedForm>
        )}
      </Edit>
    </>
  );
};
export default EditWinner;
